import { render } from "./product-grid.vue?vue&type=template&id=8cb1783a"
import script from "./product-grid.vue?vue&type=script&lang=js"
export * from "./product-grid.vue?vue&type=script&lang=js"

import "./product-grid.vue?vue&type=style&index=0&id=8cb1783a&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__